import React, { useContext } from 'react';

import type { ActionButtonType, IActionButtonProps } from '@klp/design';
import { ActionButton } from '@klp/design';

import { FormContext } from './FormContext';

interface IFormButtonProps extends Pick<
    IActionButtonProps,
    | 'translationOptions'
    | 'startIcon'
    | 'endIcon'
    | 'onClick'
    | 'clickHandler'
    | 'target'
    | 'targetParams'
    | 'isLoading'
> {
    name?: string;
    children?: React.ReactNode;
    disableOnError?: boolean;
    disabled?: boolean;
    actionType?: keyof typeof ActionButtonType;
    translation?: string;
    value?: string;
}

export const FormButton: React.FC<IFormButtonProps> = (props) => {
    const {
        name: _name,
        children,
        disableOnError,
        disabled,
        actionType = 'button',
        translation = '',
        value,
        ...rest
    } = props;

    const context = useContext(FormContext);

    const isDisabled =
        disabled ||
        (disableOnError && context.formHasErrors) ||
        context.formDisabled;

    return (
        <ActionButton
            {...rest}
            translation={translation}
            className="Form__Field Form__Button"
            disabled={isDisabled}
            actionType={actionType}
        >
            {value || children}
        </ActionButton>
    );
};
